type TableBadgeProps = {
  text: string;
  bgColorClass: string;
  className?: string;
};

const TableBadge = ({ text, bgColorClass = "bg-blue-500", className = "" }: TableBadgeProps) => (
  <span
    className={`inline-flex items-center gap-1.5 ${className}`}
    role="status"
  >
    <span className={`h-2 w-2 shrink-0 rounded-full ${bgColorClass}`}/>
    <span className="text-sm font-medium text-gray-700">{text}</span>
  </span>
);

export default TableBadge;
